import {
  USERS_FETCH,
  USER_FETCH,
  ME_FETCH,
  NOTIFICATION_FETCH,
  SEEKER_FETCH,
  CONFIG_APPLICATIONS_STATE,
} from "../constants";

const initialState = {
  me: null,
  user: null,
  users: [],
  usersCount: null,
  notifications: [],
  seeker: null,
  config_applications_state: [],
};

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case ME_FETCH:
      return { ...state, me: action.result };

    case USER_FETCH:
      return { ...state, user: action.result };

    case USERS_FETCH:
      return {
        ...state,
        users: action.result,
        usersCount: action.count,
      };

    case NOTIFICATION_FETCH:
      return { ...state, notifications: action.result };

    case SEEKER_FETCH:
      return { ...state, seeker: action.result };

    case CONFIG_APPLICATIONS_STATE:
      return {
        ...state,
        config_applications_state: action.result,
      };

    default:
      return state;
  }
}
